
import format from 'date-fns/format';

import { getDayForHourAndMin } from '../weeklyCalendar/WeeklyCalendarUtil'

const getDay = (day1, days) => {
    let day = days.find((d) => d.index == day1.dayNumber)
    return day.name

}

export const getTimeTableSlotsForExcel = (class1) => {

    let periodMap = new Map();
    class1.days.forEach(day => {
        day.periods.forEach(period => {
            let periodObj = periodMap.get(period.periodName)
            if (!periodObj) {
                periodObj = [];
                periodMap.set(period.periodName, periodObj);
            }
            let cellData = createCell(period)
            // let periodMapData = { dayNumber: day.dayNumber, cellData }
            periodObj.push(cellData);
        });
    });

    return periodMap
}
export const getTeacherTimeTableSlotsForExcel = (teacher, calendars, days) => {

    let periodMap = new Map();
    calendars.map(function (day1, index3) {
        if (day1.periods.length > 0) {

            let teacherDay = teacher.days.find((day) => day.name == getDay(day1, days));
            if (teacherDay != undefined) {
                day1.periods.map(function (period, index1) {
                    let periodObject = periodMap.get(period.periodName)
                    if (!periodObject) {
                        periodObject = [];
                        periodMap.set(period.periodName, periodObject);
                    }
                    let periodObj = teacherDay.classes.find((p) => p.period == period.periodName);
                    let colorhex8 = ''
                    let data = ''
                    let cellData = {}
                    if (periodObj != undefined) {
                        if (periodObj.typeOfPeriod != 'slot') {
                            
                            periodObj.typeOfPeriod = period.typeOfPeriod
                            data = periodObj.subject != undefined && periodObj.subject.code != undefined && periodObj.className != undefined ? periodObj.subject.code + "-" + periodObj.className : ''
                            let color = periodObj.color != undefined && periodObj.color != "" ? periodObj.color : '#FFFFFF'
                            
                            colorhex8 = color.replace("#", "ff");
                            cellData = createCellForTeacher(periodObj, colorhex8)
                        }
                        else {
                            colorhex8 = 'ffffffff'
                            cellData = createCellForTeacher(period, colorhex8)
                        }
                    } else {
                        if (period.typeOfPeriod != 'period') {
                            colorhex8 = 'ffededed'
                            cellData = createCellForTeacher(period, colorhex8)
                        } else {
                            colorhex8 = 'ffffffff'
                            cellData = createCellForTeacher(period, colorhex8)
                        }

                    }
                    periodObject.push(cellData);
                })
            }
        }
    })

    return periodMap
}
const createCellForTeacher = (period, colorhex8) => {

    //let colorhex8 = ''
    let data = ''
    // let teachers = ''
    let rooms = ''
    
    if (period.typeOfPeriod == 'period') {
        
        if (period.subject != undefined && period.subject.name != undefined && period.subject.name != '') {
            let startDateObject = getDayForHourAndMin(period.startTime_str);
            let endDateObject = getDayForHourAndMin(period.endTime_str);
            data = `${format(startDateObject, 'hh:mm')} - ${format(endDateObject, 'hh:mm a')}`

            // colorhex8 = period.subject.color
            // if (colorhex8 != undefined) {
            //     colorhex8 = colorhex8.replace("#", "ff");
            // }
            // else {
            //     colorhex8 = "ffffffff"
            // }

            
            if (period.className != undefined) {
                data = data + " - " + period.className;
            }
            data = data + " " + period.subject.name
            if (period.subject.rooms != undefined && period.subject.rooms.length > 0) {
                period.subject.rooms.map(function (room, i) {
                    rooms += '' + room
                    rooms += (period.subject.rooms.length > i + 1) ? ',' : ""
                })

                data = data + " - " + rooms;
            }

        }
        // else {
        //     colorhex8 = "ffffffff"
        // }
    }
    // else {
    //     colorhex8 = 'ffededed'
    // }
    let dataItem = {
        value: data, style: {
            fill: { patternType: "solid", fgColor: { rgb: colorhex8 } },
            alignment: { wrapText: true },
            border: {
                top: { style: "thin", color: "ffededed" },
                bottom: { style: "thin", color: "ffededed" },
                left: { style: "thin", color: "ffededed" },
                right: { style: "thin", color: "ffededed" }
            }
        }
    }

    return dataItem;
}

const createCell = (period) => {

    let colorhex8 = ''
    let data = ''
    let teachers = ''
    let rooms = ''
    if (period.typeOfPeriod == 'period') {
        
        if (period.subject != undefined && period.subject.name != undefined && period.subject.name != '') {
            let startDateObject = getDayForHourAndMin(period.startTime_str);
            let endDateObject = getDayForHourAndMin(period.endTime_str);
            data = `${format(startDateObject, 'hh:mm')} - ${format(endDateObject, 'hh:mm a')}`

            colorhex8 = period.subject.color
            if (colorhex8 != undefined) {
                colorhex8 = colorhex8.replace("#", "ff");
            }
            else {
                colorhex8 = "ffffffff"
            }
            if (period.subject.teachers.length > 0) {
                period.subject.teachers.map(function (teacher, i) {
                    teachers += '' + teacher.firstName + " " + teacher.lastName 
                    teachers += (period.subject.teachers.length > i + 1) ? ',' : ""
                })
            }
            
            data = data + " " + period.subject.name + ", " + teachers;
            if (period.subject.rooms != undefined && period.subject.rooms.length > 0) {
                period.subject.rooms.map(function (room, i) {
                    rooms += '' + room
                    rooms += (period.subject.rooms.length > i + 1) ? ',' : ""
                })

                data = data + " - " + rooms;
            }
            if (period.className != undefined) {
                data = data + " - " + period.className;
            }
        }
        else {
            colorhex8 = "ffffffff"
        }
    }
    else {
        colorhex8 = 'ffededed'
    }
    let dataItem = {
        value: data, style: {
            fill: { patternType: "solid", fgColor: { rgb: colorhex8 } },
            alignment: { wrapText: true },
            border: {
                top: { style: "thin", color: "ffededed" },
                bottom: { style: "thin", color: "ffededed" },
                left: { style: "thin", color: "ffededed" },
                right: { style: "thin", color: "ffededed" }
            }
        }
    }

    return dataItem;
}
